import { AGENT_API } from '../AgentAPI';
export function createDomainService(api) {
    return {
        getDomainList() {
            return api.fetch(AGENT_API.GET_DOMAINS);
        },
        checkDomain(domain) {
            return api.fetch(AGENT_API.GET_CHECK_DOMAIN, { config: { baseURL: domain, withCredentials: false } });
        },
        getPromoDomainList() {
            return api.fetch(AGENT_API.GET_PROMO_DOMAINS);
        },
        getPromoStaffsInfo() {
            return api.fetch(AGENT_API.GET_PROMO_STAFFS_INFO);
        },
        getPromoStaffUrls() {
            return api.fetch(AGENT_API.GET_PROMO_STAFF_URLS);
        }
    };
}
//# sourceMappingURL=DomainService.js.map